import type { AdminDashboardRouter } from "@agent/functions/adminDashboard/index";
import { createTRPCReact } from "@trpc/react-query";
import { inferRouterOutputs } from "@trpc/server";

type TRPCClient = ReturnType<typeof createTRPCReact<AdminDashboardRouter>>;
export const trpc: TRPCClient = createTRPCReact<AdminDashboardRouter>();

export type RouterOutputs = inferRouterOutputs<AdminDashboardRouter>;
